import {
    annualPriceMapping,
    CURRENT_INSCRIPTION_YEAR,
    firstInscriptionYearType,
    INSCRIPTION_FEE,
    yearType,
} from '../constants';

const REDUCTION_FOR_ESAJ_MASTER_HOLDERS = 1000;

function computePrices(params: {
    selectedPromo: yearType;
    firstInscriptionYear: firstInscriptionYearType;
    hasAlreadyAnEsajMaster: boolean;
}) {
    const { selectedPromo, firstInscriptionYear, hasAlreadyAnEsajMaster } = params;
    const annualPrice = annualPriceMapping[selectedPromo][firstInscriptionYear];
    const actualAnnualPrice =
        selectedPromo === '5A-ecologue' && hasAlreadyAnEsajMaster
            ? annualPrice - REDUCTION_FOR_ESAJ_MASTER_HOLDERS
            : annualPrice;
    const trimestrialPrice = actualAnnualPrice / 3;
    const isFirstInscription = firstInscriptionYear === CURRENT_INSCRIPTION_YEAR;
    const actualFee = isFirstInscription ? INSCRIPTION_FEE : 0;
    return {
        annualPrice: actualAnnualPrice,
        comptant: {
            fee: actualFee,
            price: actualAnnualPrice - actualFee,
            date: '30 juin 2026',
        },
        echelonne: {
            fee: actualFee,
            prices: [
                {
                    value: trimestrialPrice - actualFee,
                    date: '30 juin 2026',
                },
                { value: trimestrialPrice, date: '30 novembre 2026' },
                { value: trimestrialPrice, date: '2 mars 2027' },
            ],
        },
    };
}

export { computePrices };
